import { IDataProviderSort } from 'core-components/types'

export const PHONE_CODE_LABEL = 'Code'

export const PHONE_CODE_FIELD = 'phoneCode'

export const FIELD_FOR_SEARCH = ['value', 'phoneCode']

export const PHONE_CODE_PAGING = {
  pageSize: 1000,
  page: 0,
}

export const PHONE_CODE_SORT: IDataProviderSort = {
  dir: 'asc',
  field: 'value',
}

export const DEFAULT_PHONE_NUMBER_LENGTH = 10

export const MAX_PHONE_NUMBER_LENGTH = 15

export const DEFAULT_PHONE_NUMBER_MASK = [3, 3, 4]
export const EXTENDED_PHONE_NUMBER_MASK = [3, 3, 3, 3, 3]
